import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { useOfferBarVisible } from '../../util/offerBar';

import css from './OfferBar.module.css';

const OfferBar = props => {
  const showOfferBar = useOfferBarVisible();

  if (!showOfferBar) {
    return null;
  }

  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <p className={css.text}>
        <FormattedMessage id="OfferBar.text" />
      </p>
    </div>
  );
};

OfferBar.defaultProps = {
  rootClassName: null,
  className: null,
};

OfferBar.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
};

export default OfferBar;
